<template>
  <section class="tw-flex-auto">
    <CommonHeader />

    <section class="tw-container tw-mx-auto">
      <NuxtPage :email="emailMedia" @view-article="onViewArticle" />
    </section>
  </section>
</template>

<script setup lang="ts">
  const emailMedia = 'media@legendtrading.com'

  const onViewArticle = async (payload: any) => {
    await navigateTo({
      // name: '_tests-slug___en___default',
      name: 'newsroom-slug___en___default',
      params: { slug: payload.slug },
    })
  }
  definePageMeta({
    middleware: ['ip2location'],
  })
</script>

<style scoped lang="scss"></style>
